import qs from 'qs';

import { Credentials, HTTPRequestServicePayload, Method, Mode } from './types';

const formatBody = (body: HTTPRequestServicePayload['body']) => {
  if (body instanceof FormData) {
    return body;
  }

  return typeof body === 'object' ? JSON.stringify(body) : body;
};

const truncate = (pathname?: string) =>
  pathname?.endsWith('/') ? pathname?.slice(0, -1) : pathname;

const httpRequestService = ({
  protocol = 'https:',
  method = Method.Get,
  mode = Mode.Cors,
  query = {},
  host,
  pathname = '',
  body,
  credentials = Credentials.Include,
  headers = {},
  onError,
  ...requestOptions
}: HTTPRequestServicePayload) => {
  const search = qs.stringify(query, {
    arrayFormat: 'brackets',
    encodeValuesOnly: true,
    skipNulls: true,
  });

  return fetch(
    `${protocol}//${host}${truncate(pathname)}${search ? `?${search}` : ''}`,
    {
      method,
      body: formatBody(body),
      mode,
      credentials,
      headers,
      ...requestOptions,
    },
  ).then((response) => {
    const contentType = response.headers.get('Content-Type');

    const done = (body: ReturnType<Response['json']> | string | null) => {
      if (!response.ok && onError) {
        onError(response);
      }

      return response.ok ? body : Promise.reject(body);
    };

    if (!contentType) {
      return done(null);
    }

    if (contentType.includes('json')) {
      return response.json().then(done);
    }

    return response.text().then(done);
  });
};

export default httpRequestService;
